module.exports = __webpack_public_path__ + "img/modern_corporate.1b49d10b.jpg";